import { capturePlayerEvent } from '../observability/outbox';

import { RootState } from '../store';

function trailProgress(body: {
  action: string;
  /** Flat, page-supplied numbers/labels (e.g. `selfie_perf`). Never imagery. */
  pageProperties?: Record<string, string | number | boolean>;
  trailSessionToken: string;
  trail: string;
  story: string;
  storyPoint?: string;
  clientInfo?: {
    viewportWidth: number;
    viewportHeight: number;
    screenWidth: number;
    screenHeight: number;
    userAgent: string;
  };
}) {
  // Capture through the posthog-js singleton (init'd in src/index.tsx) instead
  // of POSTing to .io /api/trailProgress, which forwarded to the LEGACY US
  // PostHog project. Pageviews and the .com dashboards read from EU, so routing
  // these custom events through the same singleton unifies distinct_id with
  // pageviews and lands them in the EU project the dashboards query. The event
  // name is the action and the property names (trail/story/storyPoint) match
  // exactly what analytics.ts queries. capture() honours the existing GDPR
  // consent automatically (posthog-js opt_out), so no extra gating is needed.
  //
  // The event names this emits (loadTrail / loadSavedTrail / restoreSavedTrail /
  // storyPointCompleted) are the SILENT wire contract with the .com dashboard
  // queries — defined and pinned in the shared catalog `ANALYTICS_EVENTS`
  // (packages/magical-trails/src/analytics/events.ts). The `action` reaches here
  // dynamically (callers pass the event name), so it isn't wired to the catalog
  // by reference; keep any new/renamed event in sync with that file.
  if (import.meta.env.MODE === 'production') {
    try {
      const { action, pageProperties, ...properties } = body;
      // Page properties first, so a page can never overwrite the trail/story
      // keys the dashboards query by.
      capturePlayerEvent(action, { ...pageProperties, ...properties });
    } catch (error) {
      console.log('Error sending trail progress:', error);
    }
  }
}

export function trailEvent(
  event: string,
  state: RootState,
  storyPoint?: string,
  pageProperties?: Record<string, string | number | boolean>
) {
  let clientInfo;
  if (typeof window !== 'undefined') {
    clientInfo = {
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      userAgent: navigator.userAgent,
    };
  }

  trailProgress({
    action: event,
    trailSessionToken: state.trail.currentStory?.trailSessionToken || '',
    trail: state.trail.codesInLocalStorage[storyPoint || ''],
    story: state.trail.currentStory?.code || '',
    storyPoint,
    clientInfo,
    pageProperties,
  });
}

export default trailProgress;
